export default __webpack_public_path__ + "670a8afff962e0521162885be859fc05.jpg";